import { Button, HovereableFlex } from "boss-ui";
import { Box, Flex } from "reflexbox";
import styled from "styled-components";

const MainContainer = styled(Flex)`
  padding: 30px 40px;
  width: 924px;
  height: 700px;
  flex-direction: column;
`;

const FilterContainer = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

const NameFilterContainer = styled(Box)`
  width: 60%;
`;

const PartialFilterContainer = styled(Box)`
  width: 20%;
`;

const ButtonWrapper = styled(Button).attrs({ height: '38px' })``;

const RefreshIconContainer = styled(HovereableFlex)`
  width: 20px;
  margin-left: 10px;
  margin-bottom: 12px;
`;
RefreshIconContainer.displayName = 'SearchEvents-RefreshIconContainer';

const TableContainer = styled(Flex)`
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export {
  MainContainer,
  FilterContainer,
  NameFilterContainer,
  PartialFilterContainer,
  ButtonWrapper,
  RefreshIconContainer,
  TableContainer
}